import type { Currency } from '@backmarket/http-api'
import { getCustomerId } from '@backmarket/http-api/src/api-specs-crm-service/crm-service/customer'
import { useAuthStore } from '@backmarket/nuxt-layer-oauth/useAuthStore'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

export function useUpdateTrackingUserContext() {
  return {
    updateTrackingUserContext: async () => {
      const { userId } = useAuthStore()
      const { user } = useUserStore()
      const { isImpersonated } = useSellerInfoStore()
      const tracking = useTracking()
      const logger = useLogger()
      const currentMarketplace = useMarketplace().market.marketplace

      if (!userId) {
        return
      }

      try {
        const crmData = user.clientId
          ? await $httpFetch(getCustomerId)
          : undefined
        const crmId = crmData ? crmData.crmId : ''

        tracking.setUserContext({
          crmId,
          userId,
          isStaff: isImpersonated || user.isStaff,
          clientId: user.clientId,
          merchantId: user.merchantId
            ? user.merchantId.toString() + currentMarketplace
            : '',
          emailHashed: user.emailHashed || '',
          numberOfOrders: user.numberOfOrders,
          lastOrderDate: String(user.lastOrderDate),
          lifetimeRevenue: {
            currency: <Currency>user.lifetimeRevenue.currency || '',
            amount: String(user.lifetimeRevenue.amount),
          },
        })
      } catch (err) {
        const error = err as Error
        logger.error(error.message, {
          error,
          owners: ['bot-squad-seller-experience-front'],
        })
      }
    },
  }
}
